import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { Button, Divider, IconButton, Typography } from "@mui/material";
import { CloseIcon } from "../../../../assets/images";
import DrawerLoader from "../../../commons/DrawerLoader/DrawerLoader";
import { CircularAvatar } from "../../../commons";
import CandidateData from "./CandidateData";
import { hiringCheckListDataType } from "../../../../screens/HRMS/RecruitmentModule/HiringCheckList";

type CustomDrawerProps = {
  isRight: boolean;
  isOpen: boolean;
  onClose: (type: string, id?: number) => void;
  hiringCheckListData: hiringCheckListDataType;
  fetching: boolean;
  offerAccepteddata: any;
  uploadFetching:boolean;
  uploadFiles:any
  files:any;
  handleDeleteUploadedFile:(data:any)=>void;
  handleToggleAllItems: (name: string) => void;
  handleUpdateHiringCheckListData:(data:any)=>void;
  handleICAIIntimation:(e:string)=>void;
  handleFileChange:(data:React.ChangeEvent<HTMLInputElement>)=>void;
  fileInputRef:any;
  handleFileClick:()=>void;
};

const EditOfferAcceptedCandidate: React.FC<CustomDrawerProps> = ({
  isRight,
  isOpen,
  onClose,
  handleICAIIntimation,
  fetching,
  hiringCheckListData,
  offerAccepteddata,
  handleToggleAllItems,
  handleUpdateHiringCheckListData,
  uploadFetching,
  uploadFiles,
  files,
  handleDeleteUploadedFile,
  handleFileChange,
  fileInputRef,
  handleFileClick,
}) => {
  const LocalDrawerContent = (
    <Box
      className=""
      sx={{
        width: 700,
        padding: "0px 40px",
        marginTop: "16px",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "17px" }}>
            <IconButton onClick={() => onClose("close")}>
              <img width={"150%"} src={CloseIcon} alt="Close Icon" />
            </IconButton>

            <Typography
              variant="h6"
              sx={{ fontSize: "22px", fontWeight: "500" }}
            >
              Hiring Checklist
            </Typography>
          </div>

          <button
            style={{
              backgroundColor: "#dd4433",
              border: "none",
              padding: "10px 14px",
              color: "white",
              fontSize: "14px",
              borderRadius: "5px",
              fontWeight: "600",
              marginRight: "25px",
            }}
            onClick={handleUpdateHiringCheckListData}
          >

            Save Changes
          </button>
        </div>
      </Box>
      <hr style={{ margin: "2px 0px" }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2px",
        }}
      >
        {
          <Typography
            variant="h6"
            className="pt-2 mb-3"
            sx={{ fontSize: "18px", fontWeight: "500", color: "#6e7491" }}
          >
            Update hiring checklist for selected candidate.
          </Typography>
        }
      </Box>
      <Box
        sx={{
          display: "flex",
          gap:"50px"
        }}
      >
        {
          <Typography
            variant="h6"
            className=""
            sx={{ fontSize: "14px", fontWeight: "500", color: "#262a44" }}
          >
            <div
              className=""
              style={{display: "flex",gap: "7px"}}
            >
              <div>
                <CircularAvatar
                  name={`${offerAccepteddata?.name}`}
                  image={
                    offerAccepteddata?.profile_pic &&
                    offerAccepteddata?.profile_pic?.file_url
                  }
                />
              </div>
              <div>
                <span style={{ fontSize: "15px", color: "#262a44", lineHeight:"16px", fontWeight: "500" }}>{offerAccepteddata?.name}</span>
                <p
                  style={{ fontSize: "13px", color: "#6e7491", margin: "0px" }}
                >
                  {offerAccepteddata?.email}
                </p>
                <p style={{ fontSize: "13px", color: "#6e7491" }}>
                  {offerAccepteddata?.phone_number}
                </p>
              </div>
            </div>
          </Typography>
        }
        <Typography
          variant="h6"
          className=""
          sx={{ fontSize: "14px", fontWeight: "500", color: "#262a44" }}
        >
          <div
            className=""
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <div>
              <span style={{ fontSize: "15px", color: "#262a44", lineHeight:"16px",fontWeight: "500" }}>Applied For</span>
              <p style={{ fontSize: "13px", color: "#6e7491", margin: "0px" }}>
                {offerAccepteddata?.job_position?.name}
              </p>
              <p style={{ fontSize: "13px", color: "#6e7491" }}>
                {offerAccepteddata?.job_location?.name}
              </p>
            </div>
          </div>
        </Typography>
      </Box>
      {fetching && <DrawerLoader />}
      <CandidateData
        hiringCheckListData={hiringCheckListData}
        handleToggleAllItems={handleToggleAllItems}
        handleICAIIntimation={handleICAIIntimation}
        uploadFetching={uploadFetching}
        uploadFiles={uploadFiles}
        files={files}
        handleDeleteUploadedFile={handleDeleteUploadedFile}
        handleFileChange={handleFileChange}
        fileInputRef={fileInputRef}
        handleFileClick={handleFileClick}
      />

      <div></div>
    </Box>
  );
  return (
    <div>
      {isRight && (
        <>
          <Drawer anchor="right" open={isOpen} onClose={() => onClose("close")}>
            {LocalDrawerContent}
          </Drawer>
        </>
      )}
    </div>
  );
};

export default EditOfferAcceptedCandidate;
